/**
 * Токен ЛК храним отдельно от ключа `token`: Open WebUI в том же origin пишет в localStorage `token`
 * свой JWT — и перезаписывает сессию ЛК, если использовать один ключ.
 */
export const PB_TOKEN_STORAGE_KEY = '2pb_token'

function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') return null
  const part = token.split('.')[1]
  if (!part) return null
  try {
    const b64 = part.replace(/-/g, '+').replace(/_/g, '/')
    const pad = '='.repeat((4 - (b64.length % 4)) % 4)
    return JSON.parse(atob(b64 + pad))
  } catch {
    return null
  }
}

/** True если JWT похож на токен 2pb (login без jti, как в backend_python JWT при логине). */
export function isPbJwtPayload(payload) {
  if (!payload || typeof payload !== 'object') return false
  if (payload.jti != null) return false
  if (payload.login == null || payload.login === '') return false
  return true
}

/** Однократный перенос старого ключа `token` → `2pb_token`, если там был JWT ЛК (не OW). */
export function migrateLegacyPbTokenFromKeyToken() {
  if (localStorage.getItem(PB_TOKEN_STORAGE_KEY)) return
  const legacy = localStorage.getItem('token')
  if (!legacy) return
  const payload = decodeJwtPayload(legacy)
  if (!isPbJwtPayload(payload)) return
  localStorage.setItem(PB_TOKEN_STORAGE_KEY, legacy)
}

export function getPbToken() {
  migrateLegacyPbTokenFromKeyToken()
  return localStorage.getItem(PB_TOKEN_STORAGE_KEY)
}

export function setPbToken(token) {
  localStorage.setItem(PB_TOKEN_STORAGE_KEY, token)
}

/** Сброс сессии ЛК в localStorage (ключ OW `token` не трогаем — им управляет iframe Open WebUI). */
export function removePbToken() {
  localStorage.removeItem(PB_TOKEN_STORAGE_KEY)
}
